// Package Imports
import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Loading from 'components/loading/loading';

// Project Imports
// const DashboardChartMapping = lazy(
//   () => import('pages/dashboardMapping/dashboardChartMapping')
// );

const AttributeReview = lazy(
  () => import('pages/attributeReview/AttributeReview')
);
const HistoricalRoute = (
  <Route path={routeName.historialReport}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.HISTORICAL_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <AttributeReview />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default HistoricalRoute;
